import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import type { ExportSelection } from "./useSiteList";

interface ExportAccessStateDialogProps {
  open: boolean;
  selectedCount: number;
  loading: boolean;
  onClose: () => void;
  onConfirm: (selection: ExportSelection) => void;
}

export function ExportAccessStateDialog(props: ExportAccessStateDialogProps) {
  const { open, selectedCount, loading, onClose, onConfirm } = props;
  const [selection, setSelection] = useState<ExportSelection>("filtered");

  const handleConfirm = () => {
    onConfirm(selection);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Экспорт полного состояния доступов</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Выберите, какие сайты выгрузить:
        </Typography>
        <FormControl>
          <RadioGroup
            value={selection}
            onChange={(event) => setSelection(event.target.value as ExportSelection)}
          >
            <FormControlLabel value="filtered" control={<Radio />} label="С учётом применённых фильтров" />
            <FormControlLabel value="all" control={<Radio />} label="Все сайты" />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={`Выбранные сайты (${selectedCount})`}
              disabled={selectedCount === 0}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={loading}>
          Экспортировать
        </Button>
      </DialogActions>
    </Dialog>
  );
}
